import React, { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';
import { PrivateCallStatusEnum } from '@juno/client-api/model';

export enum CallUnansweredStatus {
  DECLINED = 'declined',
  TIMED_OUT = 'timed_out',
}
export interface CallStateProps {
  status?: PrivateCallStatusEnum;
  isCaller?: boolean;
  sessionId?: string;
  privateCallId?: string;
  otherUser?: {
    id: string;
    first_name: string;
    last_name: string;
    avatar: string;
  };
  dialogOpen?: boolean;
  dialogStatus?: CallUnansweredStatus;
  hasJoined?: boolean;
}

interface CallContextProps {
  callState: CallStateProps;
  setCallState: Dispatch<SetStateAction<CallStateProps>>;
}

const defaultContext: CallContextProps = {
  callState: { otherUser: undefined, status: undefined, isCaller: undefined },
  setCallState: () => {},
};

const SessionContext = createContext<CallContextProps>(defaultContext);

interface SessionsProviderProps {
  children: React.ReactNode;
}

export const SessionProvider: React.FC<SessionsProviderProps> = ({ children }) => {
  const [value, setValue] = useState<CallStateProps>(defaultContext.callState);

  const contextValue = {
    callState: value,
    setCallState: setValue,
  };
  return <SessionContext.Provider value={contextValue}>{children}</SessionContext.Provider>;
};

export const useSessionContext = () => useContext(SessionContext);
